import { clsx } from "clsx";
import { useState } from "react";
import { PROFILE_OPTIONS } from "../../data";
import type { OnboardingProfile, ProfileData } from "../../types";
import { StepShell } from "../step-shell";

interface ProfileStepProps {
	initialProfile: ProfileData | null;
	onBack: () => void;
	onContinue: (type: OnboardingProfile) => void;
}

export function ProfileStep({
	initialProfile,
	onBack,
	onContinue,
}: ProfileStepProps) {
	const [type, setType] = useState<OnboardingProfile | null>(
		initialProfile?.type ?? null,
	);

	return (
		<StepShell
			title="Qual opção descreve você?"
			description="Usamos seu perfil para personalizar as próximas etapas."
			onBack={onBack}
			onContinue={() => {
				if (type) onContinue(type);
			}}
			continueDisabled={!type}
		>
			<div className="choice-grid">
				{PROFILE_OPTIONS.map((option) => {
					const OptionIcon = option.icon;
					const isSelected = type === option.id;
					return (
						<button
							key={option.id}
							type="button"
							onClick={() => setType(option.id)}
							data-accent={option.accent}
							className={clsx("choice-card", isSelected && "is-selected")}
						>
							<span className="choice-card__icon" data-accent={option.accent}>
								<OptionIcon />
							</span>
							<span className="choice-card__title">{option.title}</span>
							<span className="choice-card__desc">{option.description}</span>
						</button>
					);
				})}
			</div>
		</StepShell>
	);
}
